import { Injectable } from '@angular/core';
import { LoaderComponent } from './component/loader.component';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class LoaderService {
  constructor(private overlay: Overlay) {}

  showLoader(s: Subscription) {
    setTimeout(() => {
      const overlayRef = this.overlay.create();
      const loaderPortal = new ComponentPortal(LoaderComponent);
      overlayRef.attach(loaderPortal);
      s.add(() => {
        overlayRef.detach();
      });
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/loader/loader.service.ts